/**
 * 深拷贝
 */
export function deepClone(obj, hash = new WeakMap()) {
  if (hash.has(obj)) {
    return obj
  }
  let res = null
  const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error]

  if ((obj && obj.constructor) && (reference.includes(obj.constructor))) {
    res = new obj.constructor(obj)
  } else if (Array.isArray(obj)) {
    res = []
    obj.forEach((e, i) => {
      res[i] = deepClone(e)
    })
  } else if (typeof obj === 'object' && obj !== null) {
    res = {}
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        res[key] = deepClone(obj[key])
      }
    }
    hash.set(obj, res)
  } else {
    res = obj
  }
  return res
}

// 页面功能公共方法
/**
 * 页面提交防抖F
 */
export const antiShake = (fn, t, no_message = false) => {
  const delay = t || 500
  let timer
  return function(val, val1) {
    const args = arguments
    if (timer) {
      if (!no_message) {
        this.$message({
          showClose: true,
          message: '请勿在' + t / 1000 + '秒内多次点击！',
          type: 'warning'
        })
      }
      clearTimeout(timer)
    }
    const callNow = !timer
    timer = setTimeout(() => {
      timer = null
    }, delay)
    if (callNow) fn.apply(this, args)
  }
}

/**
 * 获取文件后缀
 * @param filePath
 * @returns {*}
 */
export function getFileExtension(filePath) {
  return filePath.split('.').pop()
}

/**
 * 获取图片真实宽高
 * @param imageUrl
 * @returns {Promise<unknown>}
 * */
export function getImageSizeByLoading(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      resolve({
        file_width: img.naturalWidth,
        file_height: img.naturalHeight
      })
    }
    img.onerror = () => {
      resolve({ width: 0, height: 0 })
    }
    img.src = imageUrl
  })
}
